export enum SapStatus
    {
        InProgress = 2,
        Success = 1,
        Failed = 0 ,
        SystemFailure = 3,
    }